/* eslint-disable */
/* @ts-nocheck */
/* 自动生成的文件，请勿手动修改 */

import { BaseOpenapiClient, type string } from 'foca-openapi';

export namespace OpenapiClientParrot {
  export type GetClmmCoinsQuery = {
    sort?: 'price_usd' | 'change_24h' | 'volume_24h_usd' | 'tvl';
    direction?: 'asc' | 'desc';
    page?: number;
    limit?: number;

    /**
     * Coin type or name
     */
    search?: string;
  };
  export type GetClmmCoinsResponse = {
    page: number;
    limit: number;
    total: number;
    result: {
      name: string;
      symbol: string;
      coingecko_id: string;
      decimals: number;
      project_url: string;
      icon_url: string;
      coin_type: string;
      description: string;
      pyth_id: string;
      flag: number;
      from_bonding_curve: boolean;
      sort: number;
      price_usd: number;
      price_source: 'coingecko' | 'pyth' | 'parrot';
      change_24h?: number | null;
      volume_24h_usd: string;
      tvl: string;
      market_cap?: number | null;
      holders_count: number;
      is_popular: boolean;
      is_quote: boolean;
    }[];
  };
  export type GetClmmCoinsAllResponse = {
    name: string;
    symbol: string;
    coingecko_id: string;
    decimals: number;
    project_url: string;
    icon_url: string;
    coin_type: string;
    description: string;
    pyth_id: string;
    flag: number;
    from_bonding_curve: boolean;
    sort: number;
    price_usd: number;
    price_source: 'coingecko' | 'pyth' | 'parrot';
    change_24h?: number | null;
    volume_24h_usd: string;
    tvl: string;
    market_cap?: number | null;
    holders_count: number;
    is_popular: boolean;
    is_quote: boolean;
  }[];
  export type GetClmmCoinsByTokenPriceParams = { token: string };
  export type GetClmmCoinsByTokenPriceResponse = {
    price_source: 'coingecko' | 'pyth' | 'parrot';
    price_usd: number;
    change_24h?: number | null;
    coin_type: string;
  };
  export type GetClmmCoinsByTokenParams = { token: string };
  export type GetClmmCoinsByTokenResponse = {
    coin: {
      name: string;
      symbol: string;
      coingecko_id: string;
      decimals: number;
      project_url: string;
      icon_url: string;
      coin_type: string;
      description: string;
      pyth_id: string;
      flag: number;
      from_bonding_curve: boolean;
      sort: number;
      price_usd: number;
      price_source: 'coingecko' | 'pyth' | 'parrot';
      change_24h?: number | null;
      volume_24h_usd: string;
      tvl: string;
      market_cap?: number | null;
      holders_count: number;
      is_popular: boolean;
      is_quote: boolean;
    };
  };
  export type GetClmmCoinsBalanceQuery = { owner: string; tokens: string[] };
  export type GetClmmCoinsBalanceResponse = { coin_type: string; balance: string }[];
  export type GetClmmPoolsQuery = {
    /**
     * Coin type, support separator x,x,x
     */
    tokens?: string[];
    sort?: 'liquidity_usd' | 'volume_usd' | 'volume_24h_usd' | 'volume_7d_usd' | 'apr';
    direction?: 'asc' | 'desc';
    page?: number;
    limit?: number;
  };
  export type GetClmmPoolsResponse = {
    page: number;
    limit: number;
    total: number;
    result: {
      pool_type: string;
      coin_type_a: string;
      coin_type_b: string;
      coin_amount_a: string;
      coin_amount_b: string;
      current_sqrt_price: string;
      current_tick_index: number;
      fee_growth_global_b: string;
      fee_growth_global_a: string;
      fee_protocol_coin_a: string;
      fee_protocol_coin_b: string;
      fee_rate: string;
      is_pause: boolean;
      liquidity: string;
      index: number;
      position_manager: { positions_handle: string; size: number };
      rewarder_infos: {
        emissions_per_second: string;
        emissions_every_day: string;
        coin_address: string;
        growth_global: string;
      }[];
      rewarder_last_updated_time: string;
      ticks_handle: string;
      uri: string;
      name: string;
      tick_spacing: number;
      pool_id: string;
      coin_decimals_a: number;
      coin_decimals_b: number;
      swap_count: string;
      timestamp: string.DateTime;
      liquidity_usd: string;
      liquidity_a_usd: string;
      liquidity_b_usd: string;
      price_a: number;
      price_b: number;
      price_a_usd: number;
      price_b_usd: number;
      volume: string;
      volume_usd: string;
      fee: string;
      fee_usd: string;
      volume_24h: string;
      volume_24h_usd: string;
      volume_7d: string;
      volume_7d_usd: string;
      fee_24h: string;
      fee_7d: string;
      fee_24h_usd: string;
      fee_7d_usd: string;
      fee_apr: number;
      reward_apr: number;
      apr: number;
    }[];
  };
  export type GetClmmPoolsByPoolIdTicksParams = { pool_id: string };
  export type GetClmmPoolsByPoolIdTicksResponse = {
    index: number;
    sqrt_price: string;
    liquidity_net: string;
    liquidity_gross: string;
    fee_growth_outside_a: string;
    fee_growth_outside_b: string;
    rewarders_growth_outside: string[];
    pool_id: string;
    tx_digest: string;
    checkpoint: string;
    object_version: string;
    timestamp: string.DateTime;
  }[];
  export type GetClmmPoolsByPoolIdOhlcQuery = {
    start?: string.DateTime;
    end?: string.DateTime;
    step:
      | 'minute'
      | '5minute'
      | '15minute'
      | '30minute'
      | 'hour'
      | '4hour'
      | 'day'
      | 'week'
      | 'month'
      | 'year';
  };
  export type GetClmmPoolsByPoolIdOhlcParams = { pool_id: string };
  export type GetClmmPoolsByPoolIdOhlcResponse = {
    close: number;
    close_usd: number;
    count: number;
    high: number;
    high_usd: number;
    low: number;
    low_usd: number;
    open: number;
    open_usd: number;
    timestamp: number;
    volume: string;
    volume_usd: string;
  }[];
  export type GetClmmPoolsIdsQuery = {
    /**
     * Support separator x,x,x
     */
    pool_ids: string[];
  };
  export type GetClmmPoolsIdsResponse = {
    pool_type: string;
    coin_type_a: string;
    coin_type_b: string;
    coin_amount_a: string;
    coin_amount_b: string;
    current_sqrt_price: string;
    current_tick_index: number;
    fee_growth_global_b: string;
    fee_growth_global_a: string;
    fee_protocol_coin_a: string;
    fee_protocol_coin_b: string;
    fee_rate: string;
    is_pause: boolean;
    liquidity: string;
    index: number;
    position_manager: { positions_handle: string; size: number };
    rewarder_infos: {
      emissions_per_second: string;
      emissions_every_day: string;
      coin_address: string;
      growth_global: string;
    }[];
    rewarder_last_updated_time: string;
    ticks_handle: string;
    uri: string;
    name: string;
    tick_spacing: number;
    pool_id: string;
    coin_decimals_a: number;
    coin_decimals_b: number;
    swap_count: string;
    timestamp: string.DateTime;
    liquidity_usd: string;
    liquidity_a_usd: string;
    liquidity_b_usd: string;
    price_a: number;
    price_b: number;
    price_a_usd: number;
    price_b_usd: number;
    volume: string;
    volume_usd: string;
    fee: string;
    fee_usd: string;
    volume_24h: string;
    volume_24h_usd: string;
    volume_7d: string;
    volume_7d_usd: string;
    fee_24h: string;
    fee_7d: string;
    fee_24h_usd: string;
    fee_7d_usd: string;
    fee_apr: number;
    reward_apr: number;
    apr: number;
  }[];
  export type GetClmmPoolsByPoolIdParams = { pool_id: string };
  export type GetClmmPoolsByPoolIdResponse = {
    pool_type: string;
    coin_type_a: string;
    coin_type_b: string;
    coin_amount_a: string;
    coin_amount_b: string;
    current_sqrt_price: string;
    current_tick_index: number;
    fee_growth_global_b: string;
    fee_growth_global_a: string;
    fee_protocol_coin_a: string;
    fee_protocol_coin_b: string;
    fee_rate: string;
    is_pause: boolean;
    liquidity: string;
    index: number;
    position_manager: { positions_handle: string; size: number };
    rewarder_infos: {
      emissions_per_second: string;
      emissions_every_day: string;
      coin_address: string;
      growth_global: string;
    }[];
    rewarder_last_updated_time: string;
    ticks_handle: string;
    uri: string;
    name: string;
    tick_spacing: number;
    pool_id: string;
    coin_decimals_a: number;
    coin_decimals_b: number;
    swap_count: string;
    timestamp: string.DateTime;
    liquidity_usd: string;
    liquidity_a_usd: string;
    liquidity_b_usd: string;
    price_a: number;
    price_b: number;
    price_a_usd: number;
    price_b_usd: number;
    volume: string;
    volume_usd: string;
    fee: string;
    fee_usd: string;
    volume_24h: string;
    volume_24h_usd: string;
    volume_7d: string;
    volume_7d_usd: string;
    fee_24h: string;
    fee_7d: string;
    fee_24h_usd: string;
    fee_7d_usd: string;
    fee_apr: number;
    reward_apr: number;
    apr: number;
  };
  export type GetClmmTradingBestRouteQuery = {
    /**
     * Coin type
     */
    from: string;

    /**
     * Coin type
     */
    to: string;
    amount: string;
    by_amount_in: boolean;
  };
  export type GetClmmTradingBestRouteResponse = {
    data: {
      amount_in: string;
      amount_out: string;
      a2b: boolean;
      b2c?: boolean;
      coin_type_a: string;
      coin_type_b: string;
      coin_type_c?: string;
      is_exceed: boolean;
      target_sqrt_price: string[];
      current_sqrt_price: string[];
      paths: {
        amount_in: string;
        amount_out: string;
        pool_ids: string[];
        pools: {
          pool_type: string;
          coin_type_a: string;
          coin_type_b: string;
          coin_amount_a: string;
          coin_amount_b: string;
          current_sqrt_price: string;
          current_tick_index: number;
          fee_growth_global_b: string;
          fee_growth_global_a: string;
          fee_protocol_coin_a: string;
          fee_protocol_coin_b: string;
          fee_rate: string;
          is_pause: boolean;
          liquidity: string;
          index: number;
          position_manager: { positions_handle: string; size: number };
          rewarder_infos: {
            emissions_per_second: string;
            emissions_every_day: string;
            coin_address: string;
            growth_global: string;
          }[];
          rewarder_last_updated_time: string;
          ticks_handle: string;
          uri: string;
          name: string;
          tick_spacing: number;
          pool_id: string;
          coin_decimals_a: number;
          coin_decimals_b: number;
          swap_count: string;
          timestamp: string.DateTime;
          liquidity_usd: string;
          liquidity_a_usd: string;
          liquidity_b_usd: string;
          price_a: number;
          price_b: number;
          price_a_usd: number;
          price_b_usd: number;
          volume: string;
          volume_usd: string;
          fee: string;
          fee_usd: string;
          volume_24h: string;
          volume_24h_usd: string;
          volume_7d: string;
          volume_7d_usd: string;
          fee_24h: string;
          fee_7d: string;
          fee_24h_usd: string;
          fee_7d_usd: string;
          fee_apr: number;
          reward_apr: number;
          apr: number;
        }[];
        a2b: boolean[];
        raw_amount_limit: (string | null)[];
        is_exceed: boolean;
        coin_types: string[];
      }[];
    } | null;
    error: string | null;
  };
  export type GetStatsSummaryResponse = { tvl: number; volume_usd: number; wallet_count: number };
  export type GetStatsChartVolumesQuery = { period: number; unit: 'day' | 'month' | 'week' };
  export type GetStatsChartVolumesResponse = { timestamp: number; volume_usd: number }[];
  export type GetStatsChartTvlQuery = { period: number; unit: 'day' | 'month' | 'week' };
  export type GetStatsChartTvlResponse = { timestamp: number; tvl: number }[];
  export type GetUsersByWalletParams = { wallet: string };
  export type GetUsersByWalletResponse = {
    wallet_address: string;
    avatar: string | null;
    username: string | null;
    username_edit_at: string.DateTime | null;
  };
  export type GetFunCoinsByOwnerOwnedParams = { owner: string };
  export type GetFunCoinsByOwnerOwnedResponse = {
    balance: string;
    coin: {
      bonding_curve: string;
      created_by: string;
      description: string;
      name: string;
      pool_id: string;
      symbol: string;
      telegram: string;
      token_address: string;
      twitter: string;
      uri: string;
      real_sui_reserves: string;
      real_token_reserves: string;
      virtual_sui_reserves: string;
      virtual_token_reserves: string;
      remain_token_reserves: string;
      website: string;
      deployment_fee: string;
      token_supply: string;
      token_id: string;
      timestamp: string.DateTime;
      token_decimals: number;
      holders_count: number;
      holders_balance: string;
      comment_count: number;
      is_completed: boolean;
      token_price: number;
      token_price_usd: number;
      market_cap: number;
      market_cap_usd: number;
      volume_24h: string;
      volume_24h_usd: string;
      volume: string;
      volume_usd: string;
      clmm_pool_id?: string | null;
      /**
       * Timestamp
       */
      king_timestamp_ms?: number | null;
      completed_at?: string.DateTime | null;
      /**
       * Timestamp
       */
      latest_trade_timestamp_ms: number;
      latest_trade_is_buy: boolean;
      progress: number;
      change24h?: number | null;
    };
  }[];
  export type GetFunCoinsByTokenHoldersParams = { token: string };
  export type GetFunCoinsByTokenHoldersResponse = {
    owner_address: string;
    balance: string;
    percentage: string | null;
  }[];
  export type GetFunCommentsByTokenListQuery = { page?: number; limit?: number };
  export type GetFunCommentsByTokenListParams = { token: string };
  export type GetFunCommentsByTokenListResponse = {
    page: number;
    limit: number;
    total: number;
    result: {
      id: number;
      token_address: string;
      wallet_address: string;
      content: string;
      attach_image: string | null;
      created_at: string.DateTime;
      user: {
        wallet_address: string;
        avatar: string | null;
        username: string | null;
        username_edit_at: string.DateTime | null;
      } | null;
    }[];
  };
  export type GetFunPoolsQuery = {
    /**
     * Token symbol, name or type
     */
    search?: string;
    sort?: 'latest_trade_timestamp_ms' | 'timestamp' | 'volume' | 'market_cap' | 'comment_count';
    direction?: 'asc' | 'desc';
    completed?: boolean;
    creator?: string;
    page?: number;
    limit?: number;
  };
  export type GetFunPoolsResponse = {
    page: number;
    limit: number;
    total: number;
    result: {
      bonding_curve: string;
      created_by: string;
      description: string;
      name: string;
      pool_id: string;
      symbol: string;
      telegram: string;
      token_address: string;
      twitter: string;
      uri: string;
      real_sui_reserves: string;
      real_token_reserves: string;
      virtual_sui_reserves: string;
      virtual_token_reserves: string;
      remain_token_reserves: string;
      website: string;
      deployment_fee: string;
      token_supply: string;
      token_id: string;
      timestamp: string.DateTime;
      token_decimals: number;
      holders_count: number;
      holders_balance: string;
      comment_count: number;
      is_completed: boolean;
      token_price: number;
      token_price_usd: number;
      market_cap: number;
      market_cap_usd: number;
      volume_24h: string;
      volume_24h_usd: string;
      volume: string;
      volume_usd: string;
      clmm_pool_id?: string | null;
      /**
       * Timestamp
       */
      king_timestamp_ms?: number | null;
      completed_at?: string.DateTime | null;
      /**
       * Timestamp
       */
      latest_trade_timestamp_ms: number;
      latest_trade_is_buy: boolean;
      progress: number;
      change24h?: number | null;
      user: {
        wallet_address: string;
        avatar: string | null;
        username: string | null;
        username_edit_at: string.DateTime | null;
      } | null;
    }[];
  };
  export type GetFunPoolsTopMarketCapQuery = { limit?: number };
  export type GetFunPoolsTopMarketCapResponse = {
    bonding_curve: string;
    created_by: string;
    description: string;
    name: string;
    pool_id: string;
    symbol: string;
    telegram: string;
    token_address: string;
    twitter: string;
    uri: string;
    real_sui_reserves: string;
    real_token_reserves: string;
    virtual_sui_reserves: string;
    virtual_token_reserves: string;
    remain_token_reserves: string;
    website: string;
    deployment_fee: string;
    token_supply: string;
    token_id: string;
    timestamp: string.DateTime;
    token_decimals: number;
    holders_count: number;
    holders_balance: string;
    comment_count: number;
    is_completed: boolean;
    token_price: number;
    token_price_usd: number;
    market_cap: number;
    market_cap_usd: number;
    volume_24h: string;
    volume_24h_usd: string;
    volume: string;
    volume_usd: string;
    clmm_pool_id?: string | null;
    /**
     * Timestamp
     */
    king_timestamp_ms?: number | null;
    completed_at?: string.DateTime | null;
    /**
     * Timestamp
     */
    latest_trade_timestamp_ms: number;
    latest_trade_is_buy: boolean;
    progress: number;
    change24h?: number | null;
    user: {
      wallet_address: string;
      avatar: string | null;
      username: string | null;
      username_edit_at: string.DateTime | null;
    } | null;
  }[];
  export type GetFunPoolsTopBoundingCurveQuery = { limit?: number };
  export type GetFunPoolsTopBoundingCurveResponse = {
    bonding_curve: string;
    created_by: string;
    description: string;
    name: string;
    pool_id: string;
    symbol: string;
    telegram: string;
    token_address: string;
    twitter: string;
    uri: string;
    real_sui_reserves: string;
    real_token_reserves: string;
    virtual_sui_reserves: string;
    virtual_token_reserves: string;
    remain_token_reserves: string;
    website: string;
    deployment_fee: string;
    token_supply: string;
    token_id: string;
    timestamp: string.DateTime;
    token_decimals: number;
    holders_count: number;
    holders_balance: string;
    comment_count: number;
    is_completed: boolean;
    token_price: number;
    token_price_usd: number;
    market_cap: number;
    market_cap_usd: number;
    volume_24h: string;
    volume_24h_usd: string;
    volume: string;
    volume_usd: string;
    clmm_pool_id?: string | null;
    /**
     * Timestamp
     */
    king_timestamp_ms?: number | null;
    completed_at?: string.DateTime | null;
    /**
     * Timestamp
     */
    latest_trade_timestamp_ms: number;
    latest_trade_is_buy: boolean;
    progress: number;
    change24h?: number | null;
    user: {
      wallet_address: string;
      avatar: string | null;
      username: string | null;
      username_edit_at: string.DateTime | null;
    } | null;
  }[];
  export type GetFunPoolsKingResponse = {
    pool: {
      bonding_curve: string;
      created_by: string;
      description: string;
      name: string;
      pool_id: string;
      symbol: string;
      telegram: string;
      token_address: string;
      twitter: string;
      uri: string;
      real_sui_reserves: string;
      real_token_reserves: string;
      virtual_sui_reserves: string;
      virtual_token_reserves: string;
      remain_token_reserves: string;
      website: string;
      deployment_fee: string;
      token_supply: string;
      token_id: string;
      timestamp: string.DateTime;
      token_decimals: number;
      holders_count: number;
      holders_balance: string;
      comment_count: number;
      is_completed: boolean;
      token_price: number;
      token_price_usd: number;
      market_cap: number;
      market_cap_usd: number;
      volume_24h: string;
      volume_24h_usd: string;
      volume: string;
      volume_usd: string;
      clmm_pool_id?: string | null;
      /**
       * Timestamp
       */
      king_timestamp_ms?: number | null;
      completed_at?: string.DateTime | null;
      /**
       * Timestamp
       */
      latest_trade_timestamp_ms: number;
      latest_trade_is_buy: boolean;
      progress: number;
      change24h?: number | null;
      user: {
        wallet_address: string;
        avatar: string | null;
        username: string | null;
        username_edit_at: string.DateTime | null;
      } | null;
    } | null;
  };
  export type GetFunPoolsFeaturedResponse = {
    pool: {
      bonding_curve: string;
      created_by: string;
      description: string;
      name: string;
      pool_id: string;
      symbol: string;
      telegram: string;
      token_address: string;
      twitter: string;
      uri: string;
      real_sui_reserves: string;
      real_token_reserves: string;
      virtual_sui_reserves: string;
      virtual_token_reserves: string;
      remain_token_reserves: string;
      website: string;
      deployment_fee: string;
      token_supply: string;
      token_id: string;
      timestamp: string.DateTime;
      token_decimals: number;
      holders_count: number;
      holders_balance: string;
      comment_count: number;
      is_completed: boolean;
      token_price: number;
      token_price_usd: number;
      market_cap: number;
      market_cap_usd: number;
      volume_24h: string;
      volume_24h_usd: string;
      volume: string;
      volume_usd: string;
      clmm_pool_id?: string | null;
      /**
       * Timestamp
       */
      king_timestamp_ms?: number | null;
      completed_at?: string.DateTime | null;
      /**
       * Timestamp
       */
      latest_trade_timestamp_ms: number;
      latest_trade_is_buy: boolean;
      progress: number;
      change24h?: number | null;
      user: {
        wallet_address: string;
        avatar: string | null;
        username: string | null;
        username_edit_at: string.DateTime | null;
      } | null;
    } | null;
  };
  export type GetFunPoolsByTokenParams = { token: string };
  export type GetFunPoolsByTokenResponse = {
    bonding_curve: string;
    created_by: string;
    description: string;
    name: string;
    pool_id: string;
    symbol: string;
    telegram: string;
    token_address: string;
    twitter: string;
    uri: string;
    real_sui_reserves: string;
    real_token_reserves: string;
    virtual_sui_reserves: string;
    virtual_token_reserves: string;
    remain_token_reserves: string;
    website: string;
    deployment_fee: string;
    token_supply: string;
    token_id: string;
    timestamp: string.DateTime;
    token_decimals: number;
    holders_count: number;
    holders_balance: string;
    comment_count: number;
    is_completed: boolean;
    token_price: number;
    token_price_usd: number;
    market_cap: number;
    market_cap_usd: number;
    volume_24h: string;
    volume_24h_usd: string;
    volume: string;
    volume_usd: string;
    clmm_pool_id?: string | null;
    /**
     * Timestamp
     */
    king_timestamp_ms?: number | null;
    completed_at?: string.DateTime | null;
    /**
     * Timestamp
     */
    latest_trade_timestamp_ms: number;
    latest_trade_is_buy: boolean;
    progress: number;
    change24h?: number | null;
    user: {
      wallet_address: string;
      avatar: string | null;
      username: string | null;
      username_edit_at: string.DateTime | null;
    } | null;
  };
  export type GetFunPoolsByTokenOhlcQuery = {
    start?: string.DateTime;
    end?: string.DateTime;
    step:
      | 'minute'
      | '5minute'
      | '15minute'
      | '30minute'
      | 'hour'
      | '4hour'
      | 'day'
      | 'week'
      | 'month'
      | 'year';
  };
  export type GetFunPoolsByTokenOhlcParams = { token: string };
  export type GetFunPoolsByTokenOhlcResponse = {
    close: number;
    close_usd: number;
    count: number;
    high: number;
    high_usd: number;
    low: number;
    low_usd: number;
    open: number;
    open_usd: number;
    timestamp: number;
    volume: string;
    volume_usd: string;
  }[];
  export type GetFunPoolsByTokenTradesQuery = {
    op?: 'buy' | 'sell';
    page?: number;
    limit?: number;
  };
  export type GetFunPoolsByTokenTradesParams = { token: string };
  export type GetFunPoolsByTokenTradesResponse = {
    page: number;
    limit: number;
    total: number;
    result: {
      tx_digest: string;
      sender: string;
      timestamp: string.DateTime;
      token_amount: number;
      sui_amount: number;
      is_buy: boolean;
      user: {
        wallet_address: string;
        avatar: string | null;
        username: string | null;
        username_edit_at: string.DateTime | null;
      } | null;
    }[];
  };
  export type GetFunPreheatResponse = {
    id: number;
    wallet_address: string;
    name: string;
    symbol: string;
    logo: string;
    description: string;
    twitter: string;
    telegram: string;
    website: string;
    agent_enable: boolean;
    agent_age: number | null;
    agent_first_message: string | null;
    agent_personality: string | null;
    agent_style: string | null;
    agent_adjective: string | null;
    agent_knowledge: string | null;
    is_published: boolean;
    created_at: string.DateTime;
    updated_at: string.DateTime;
  };
  export type GetResponse = string;
  export type PostPassportNonceBody = { walletAddress: string };
  export type PostPassportNonceResponse = { nonce: string };
  export type PostPassportAuthBody = { wallet_address: string; signature: string };
  export type PostPassportAuthResponse = {
    token: string;
    wallet_address: string;
    /**
     * Expires timestamp (MS)
     */
    expires_at: number;
  };
  export type PostFunCommentsByTokenParams = { token: string };
  export type PostFunCommentsByTokenBody = { content: string; file?: Blob };
  export type PostFunCommentsByTokenResponse = {
    id: number;
    token_address: string;
    wallet_address: string;
    content: string;
    attach_image: string | null;
    created_at: string.DateTime;
    user: {
      wallet_address: string;
      avatar: string | null;
      username: string | null;
      username_edit_at: string.DateTime | null;
    } | null;
  };
  export type PostFunPreheatBody = {
    name: string;
    symbol: string;
    logo: string.Uri;
    description: string;
    twitter?: string.Uri;
    telegram?: string.Uri;
    website?: string.Uri;
    agent_enable: boolean;
    agent_age?: number;
    agent_adjective?: string;
    agent_first_message?: string;
    agent_knowledge?: string;
    agent_personality?: string;
    agent_style?: string;
  };
  export type PostFunPreheatResponse = {
    id: number;
    wallet_address: string;
    name: string;
    symbol: string;
    logo: string;
    description: string;
    twitter: string;
    telegram: string;
    website: string;
    agent_enable: boolean;
    agent_age: number | null;
    agent_first_message: string | null;
    agent_personality: string | null;
    agent_style: string | null;
    agent_adjective: string | null;
    agent_knowledge: string | null;
    is_published: boolean;
    created_at: string.DateTime;
    updated_at: string.DateTime;
  };
  export type PostFunPreheatLogoBody = { file: Blob };
  export type PostFunPreheatLogoResponse = { url: string.Uri };
  export type PatchUsersBody = { file?: Blob; username?: string };
  export type PatchUsersResponse = {
    wallet_address: string;
    avatar: string | null;
    username: string | null;
    username_edit_at: string.DateTime | null;
  };
}

export class OpenapiClientParrot<T extends object = object> extends BaseOpenapiClient<T> {
  get<K extends keyof OpenapiClientParrot_get_paths>(
    uri: K,
    ...rest: K extends '/clmm/coins | /clmm/coins/all | /clmm/pools | /stats/summary | /fun/pools | /fun/pools/top/market-cap | /fun/pools/top/bounding-curve | /fun/pools/king | /fun/pools/featured | /fun/preheat | /'
      ? [opts?: OpenapiClientParrot_get_paths[K]['request'] & BaseOpenapiClient.UserInputOpts<T>]
      : [opts: OpenapiClientParrot_get_paths[K]['request'] & BaseOpenapiClient.UserInputOpts<T>]
  ): Promise<OpenapiClientParrot_get_paths[K]['response']> {
    return this.request(uri, 'get', ...rest);
  }

  post<K extends keyof OpenapiClientParrot_post_paths>(
    uri: K,
    ...rest: [
      opts: OpenapiClientParrot_post_paths[K]['request'] & BaseOpenapiClient.UserInputOpts<T>,
    ]
  ): Promise<OpenapiClientParrot_post_paths[K]['response']> {
    return this.request(uri, 'post', ...rest);
  }

  patch<K extends keyof OpenapiClientParrot_patch_paths>(
    uri: K,
    ...rest: K extends '/fun/preheat/publish'
      ? [opts?: OpenapiClientParrot_patch_paths[K]['request'] & BaseOpenapiClient.UserInputOpts<T>]
      : [opts: OpenapiClientParrot_patch_paths[K]['request'] & BaseOpenapiClient.UserInputOpts<T>]
  ): Promise<OpenapiClientParrot_patch_paths[K]['response']> {
    return this.request(uri, 'patch', ...rest);
  }

  protected override pickContentTypes(uri: string, method: string) {
    return contentTypes[method + ' ' + uri] || [void 0, void 0];
  }
}

interface OpenapiClientParrot_get_paths {
  '/clmm/coins': BaseOpenapiClient.Prettify<{
    request: {
      query?: OpenapiClientParrot.GetClmmCoinsQuery;
    };
    response: OpenapiClientParrot.GetClmmCoinsResponse;
  }>;
  '/clmm/coins/all': BaseOpenapiClient.Prettify<{
    request: {
      query?: object;
    };
    response: OpenapiClientParrot.GetClmmCoinsAllResponse;
  }>;
  '/clmm/coins/{token}/price': BaseOpenapiClient.Prettify<{
    request: {
      query?: object;
      params: OpenapiClientParrot.GetClmmCoinsByTokenPriceParams;
    };
    response: OpenapiClientParrot.GetClmmCoinsByTokenPriceResponse;
  }>;
  '/clmm/coins/{token}': BaseOpenapiClient.Prettify<{
    request: {
      query?: object;
      params: OpenapiClientParrot.GetClmmCoinsByTokenParams;
    };
    response: OpenapiClientParrot.GetClmmCoinsByTokenResponse;
  }>;
  '/clmm/coins/balance': BaseOpenapiClient.Prettify<{
    request: {
      query: OpenapiClientParrot.GetClmmCoinsBalanceQuery;
    };
    response: OpenapiClientParrot.GetClmmCoinsBalanceResponse;
  }>;
  '/clmm/pools': BaseOpenapiClient.Prettify<{
    request: {
      query?: OpenapiClientParrot.GetClmmPoolsQuery;
    };
    response: OpenapiClientParrot.GetClmmPoolsResponse;
  }>;
  '/clmm/pools/{pool_id}/ticks': BaseOpenapiClient.Prettify<{
    request: {
      query?: object;
      params: OpenapiClientParrot.GetClmmPoolsByPoolIdTicksParams;
    };
    response: OpenapiClientParrot.GetClmmPoolsByPoolIdTicksResponse;
  }>;
  '/clmm/pools/{pool_id}/ohlc': BaseOpenapiClient.Prettify<{
    request: {
      query: OpenapiClientParrot.GetClmmPoolsByPoolIdOhlcQuery;
      params: OpenapiClientParrot.GetClmmPoolsByPoolIdOhlcParams;
    };
    response: OpenapiClientParrot.GetClmmPoolsByPoolIdOhlcResponse;
  }>;
  '/clmm/pools/ids': BaseOpenapiClient.Prettify<{
    request: {
      query: OpenapiClientParrot.GetClmmPoolsIdsQuery;
    };
    response: OpenapiClientParrot.GetClmmPoolsIdsResponse;
  }>;
  '/clmm/pools/{pool_id}': BaseOpenapiClient.Prettify<{
    request: {
      query?: object;
      params: OpenapiClientParrot.GetClmmPoolsByPoolIdParams;
    };
    response: OpenapiClientParrot.GetClmmPoolsByPoolIdResponse;
  }>;
  '/clmm/trading/best-route': BaseOpenapiClient.Prettify<{
    request: {
      query: OpenapiClientParrot.GetClmmTradingBestRouteQuery;
    };
    response: OpenapiClientParrot.GetClmmTradingBestRouteResponse;
  }>;
  '/stats/summary': BaseOpenapiClient.Prettify<{
    request: {
      query?: object;
    };
    response: OpenapiClientParrot.GetStatsSummaryResponse;
  }>;
  '/stats/chart/volumes': BaseOpenapiClient.Prettify<{
    request: {
      query: OpenapiClientParrot.GetStatsChartVolumesQuery;
    };
    response: OpenapiClientParrot.GetStatsChartVolumesResponse;
  }>;
  '/stats/chart/tvl': BaseOpenapiClient.Prettify<{
    request: {
      query: OpenapiClientParrot.GetStatsChartTvlQuery;
    };
    response: OpenapiClientParrot.GetStatsChartTvlResponse;
  }>;
  '/users/{wallet}': BaseOpenapiClient.Prettify<{
    request: {
      query?: object;
      params: OpenapiClientParrot.GetUsersByWalletParams;
    };
    response: OpenapiClientParrot.GetUsersByWalletResponse;
  }>;
  '/fun/coins/{owner}/owned': BaseOpenapiClient.Prettify<{
    request: {
      query?: object;
      params: OpenapiClientParrot.GetFunCoinsByOwnerOwnedParams;
    };
    response: OpenapiClientParrot.GetFunCoinsByOwnerOwnedResponse;
  }>;
  '/fun/coins/{token}/holders': BaseOpenapiClient.Prettify<{
    request: {
      query?: object;
      params: OpenapiClientParrot.GetFunCoinsByTokenHoldersParams;
    };
    response: OpenapiClientParrot.GetFunCoinsByTokenHoldersResponse;
  }>;
  '/fun/comments/{token}/list': BaseOpenapiClient.Prettify<{
    request: {
      query?: OpenapiClientParrot.GetFunCommentsByTokenListQuery;
      params: OpenapiClientParrot.GetFunCommentsByTokenListParams;
    };
    response: OpenapiClientParrot.GetFunCommentsByTokenListResponse;
  }>;
  '/fun/pools': BaseOpenapiClient.Prettify<{
    request: {
      query?: OpenapiClientParrot.GetFunPoolsQuery;
    };
    response: OpenapiClientParrot.GetFunPoolsResponse;
  }>;
  '/fun/pools/top/market-cap': BaseOpenapiClient.Prettify<{
    request: {
      query?: OpenapiClientParrot.GetFunPoolsTopMarketCapQuery;
    };
    response: OpenapiClientParrot.GetFunPoolsTopMarketCapResponse;
  }>;
  '/fun/pools/top/bounding-curve': BaseOpenapiClient.Prettify<{
    request: {
      query?: OpenapiClientParrot.GetFunPoolsTopBoundingCurveQuery;
    };
    response: OpenapiClientParrot.GetFunPoolsTopBoundingCurveResponse;
  }>;
  '/fun/pools/king': BaseOpenapiClient.Prettify<{
    request: {
      query?: object;
    };
    response: OpenapiClientParrot.GetFunPoolsKingResponse;
  }>;
  '/fun/pools/featured': BaseOpenapiClient.Prettify<{
    request: {
      query?: object;
    };
    response: OpenapiClientParrot.GetFunPoolsFeaturedResponse;
  }>;
  '/fun/pools/{token}': BaseOpenapiClient.Prettify<{
    request: {
      query?: object;
      params: OpenapiClientParrot.GetFunPoolsByTokenParams;
    };
    response: OpenapiClientParrot.GetFunPoolsByTokenResponse;
  }>;
  '/fun/pools/{token}/ohlc': BaseOpenapiClient.Prettify<{
    request: {
      query: OpenapiClientParrot.GetFunPoolsByTokenOhlcQuery;
      params: OpenapiClientParrot.GetFunPoolsByTokenOhlcParams;
    };
    response: OpenapiClientParrot.GetFunPoolsByTokenOhlcResponse;
  }>;
  '/fun/pools/{token}/trades': BaseOpenapiClient.Prettify<{
    request: {
      query?: OpenapiClientParrot.GetFunPoolsByTokenTradesQuery;
      params: OpenapiClientParrot.GetFunPoolsByTokenTradesParams;
    };
    response: OpenapiClientParrot.GetFunPoolsByTokenTradesResponse;
  }>;
  '/fun/preheat': BaseOpenapiClient.Prettify<{
    request: {
      query?: object;
    };
    response: OpenapiClientParrot.GetFunPreheatResponse;
  }>;
  '/': BaseOpenapiClient.Prettify<{
    request: {
      query?: object;
    };
    response: OpenapiClientParrot.GetResponse;
  }>;
}
interface OpenapiClientParrot_post_paths {
  '/passport/nonce': BaseOpenapiClient.Prettify<{
    request: {
      query?: object;

      body: OpenapiClientParrot.PostPassportNonceBody;
    };
    response: OpenapiClientParrot.PostPassportNonceResponse;
  }>;
  '/passport/auth': BaseOpenapiClient.Prettify<{
    request: {
      query?: object;

      body: OpenapiClientParrot.PostPassportAuthBody;
    };
    response: OpenapiClientParrot.PostPassportAuthResponse;
  }>;
  '/fun/comments/{token}': BaseOpenapiClient.Prettify<{
    request: {
      query?: object;
      params: OpenapiClientParrot.PostFunCommentsByTokenParams;
      body: OpenapiClientParrot.PostFunCommentsByTokenBody;
    };
    response: OpenapiClientParrot.PostFunCommentsByTokenResponse;
  }>;
  '/fun/preheat': BaseOpenapiClient.Prettify<{
    request: {
      query?: object;

      body: OpenapiClientParrot.PostFunPreheatBody;
    };
    response: OpenapiClientParrot.PostFunPreheatResponse;
  }>;
  '/fun/preheat/logo': BaseOpenapiClient.Prettify<{
    request: {
      query?: object;

      body: OpenapiClientParrot.PostFunPreheatLogoBody;
    };
    response: OpenapiClientParrot.PostFunPreheatLogoResponse;
  }>;
}
interface OpenapiClientParrot_patch_paths {
  '/users': BaseOpenapiClient.Prettify<{
    request: {
      query?: object;

      body: OpenapiClientParrot.PatchUsersBody;
    };
    response: OpenapiClientParrot.PatchUsersResponse;
  }>;
  '/fun/preheat/publish': BaseOpenapiClient.Prettify<{
    request: {
      query?: object;
    };
    response: unknown;
  }>;
}

const contentTypes: Record<
  string,
  [
    BaseOpenapiClient.UserInputOpts['requestBodyType'],
    BaseOpenapiClient.UserInputOpts['responseType'],
  ]
> = {
  'get /': [void 0, 'text'],

  'post /fun/comments/{token}': ['multipart/form-data', void 0],

  'post /fun/preheat/logo': ['multipart/form-data', void 0],

  'patch /users': ['multipart/form-data', void 0],
};
